import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5分間はキャッシュを新鮮と見なす
      gcTime: 10 * 60 * 1000, // 10分間キャッシュを保持
      retry: 1, // 失敗時1回リトライ
      refetchOnWindowFocus: false, // ウィンドウフォーカス時の自動再取得を無効化
      refetchOnMount: true, // マウント時に再取得
      refetchOnReconnect: true, // 再接続時に再取得
    },
    mutations: {
      retry: 0, // ミューテーションは自動リトライしない
    },
  },
})
